import { render, staticRenderFns } from "./TaskFeedBack.vue?vue&type=template&id=6dfad8e6&scoped=true&"
import script from "./TaskFeedBack.vue?vue&type=script&lang=js&"
export * from "./TaskFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./TaskFeedBack.vue?vue&type=style&index=0&id=6dfad8e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfad8e6",
  null
  
)

export default component.exports